<template>
  <div class="vehicle-image">
    <div v-if="derivative && imageSrc">
      <div v-if="showMain" class="vehicle-image-main">
        <img :src="imageSrc" :alt="imageAlt" class="img-fluid" :class="{ 'clickable':hasImage && enableGallery }" :style="[{}, styleOverrides]" @click.self="openGallery(0)">
      </div>
      <div v-if="showThumbs" class="vehicle-image-thumbs">
        <div class="thumb-row mb-3 mt-3">
          <div v-for="(url, index) in derivative.imageThumbs" class="thumb-col">
            <img :src="url" alt="Vehicle Thumbnail" class="img-fluid" :class="{ 'clickable':enableGallery }" @click.self="openGallery(index)" />
          </div>
        </div>
      </div>
      <vehicle-gallery :visible="derivative.images.length > 0 && galleryOpen" :images="derivative.images" :thumbs="derivative.imageThumbs" :startingIndex="galleryIndex"/>
    </div>
    <div v-else class="loading-section">
      <loading-icon></loading-icon>
    </div>
  </div>
</template>

<script>
import LoadingIcon from "../loading-icon";
import { EventBus } from '@/event-bus';
import VehicleGallery from '@/components/vehicle-details/vehicle-gallery';

export default {
  components: {LoadingIcon},
  props: {
    derivative: null,
    styleOverrides: {},
    showMain: true,
    showThumbs: false,
    enableGallery: false,
  },
  data() {
    return {
      imageSrc: null,
      hasImage: 0,
      galleryOpen: false,
      galleryIndex: 0
    }
  },
  watch: {
    derivative: {
      deep: true,
      handler(value) {
        if (value) {
          this.setImage();
        }
      }
    }
  },
  mounted() {
    if (this.derivative) {
      this.setImage();
    }

    EventBus.$on('vehicle-gallery-close', () => {
      this.galleryOpen = false;
    });
    EventBus.$on('vehicle-gallery-open', (derivativeId) => {
      if (this.derivative.derivativeID === derivativeId) {
        this.openGallery(0);
      }
    });
  },
  computed: {
    imageAlt() {
      return this.derivative?.manufacturerName ? this.derivative.manufacturerName + ' ' + this.derivative.modelName : '';
    }
  },
  methods: {
    async setImage() {
      if (this.derivative?.mainImage) {
        this.imageSrc = this.derivative.mainImage;
        this.hasImage = 1;
      } else {
        this.imageSrc = '/images/fallback-image@2x-100.png';
      }
    },
    openGallery(index) {
      if (!this.enableGallery || this?.derivative?.images?.length < 1) {
        return;
      }
      this.galleryIndex = index;
      this.galleryOpen = true;
    },
  }
};
</script>

<style type="text/scss">

.loading-section {
  display: flex;
  justify-content: center;
  align-items: center;
}

.vehicle-image-main {
  text-align: center;
}

.clickable {
  cursor: pointer;
}

.thumb-row {
  display:flex;
}

.thumb-col {
  flex: 0 0 auto;
  width: 25%;
  padding: 0 2px;
}

</style>
